import script from "./Services.vue?vue&type=script&setup=true&lang=ts"
export * from "./Services.vue?vue&type=script&setup=true&lang=ts"

import "./Services.vue?vue&type=style&index=0&id=e61006e2&lang=postcss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e61006e2"]])

export default __exports__